import cardStyles from "../../styles/card.module.css";

const KpiCard = ({
  classes,
  icon,
  title,
  children,
}: {
  classes: string;
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <div className={`${cardStyles.kpiCard} ${classes}`}>
      <div className={cardStyles.kpiCardHeader}>
        {icon}
        <h1 style={{ font: "var(--font-h1)" }}>{title}</h1>
      </div>
      {children}
    </div>
  );
};

export default KpiCard;
